<div class="PGTimetableEditor">
    @if (timetableMode == 'slots') {
        <div class="form-group row">
            <div class="col-12 col-sm-6">
                <label>
                    <b>{{ 'pg-timetable-editor.experience-duration' | locTranslate }}</b>
                </label>
                <span class="{{isSlotDurationInvalid() ? 'ng-invalid' : ''}}">
                    <app-pg-time-picker [ngModel]="getSlotDuration()" (ngModelChange)="setSlotDuration($event);" [required]="required"></app-pg-time-picker>
                </span>
            </div>
            <div class="col-12 col-sm-6">
                <label>
                    <b>{{ 'pg-timetable-editor.timezone' | locTranslate }}</b>
                </label>
                @if (timezone != null) {
                    <div>{{timezone}}</div>
                }
                @if (timezone == null) {
                    <div class="{{getTimezone() == null ? 'ng-invalid' : ''}}">
                        <input class="form-control" [ngModel]="getTimezone()" (ngModelChange)="setTimezone($event);" [required]="required"/>
                    </div>
                }
            </div>
        </div>
    }

    @if (timetableMode == 'departures') {
        <div class="form-group row">
            <div class="col-12 col-sm-6">
                <label>
                    <b>{{ 'pg-timetable-editor.package-duration' | locTranslate }}</b>
                </label>
                <span class="{{isSlotDurationInvalid() ? 'ng-invalid' : ''}}">
                    <input class="form-control" type="number" min="1" step="1" [ngModel]="getSlotDuration(true)" (ngModelChange)="setSlotDuration($event, true);" [required]="required"/>
                </span>
            </div>
            <div class="col-12 col-sm-6">
                <label>
                    <b>{{ 'pg-timetable-editor.timezone' | locTranslate }}</b>
                </label>
                <span class="{{getTimezone() == null ? 'ng-invalid' : ''}}">
                    <input class="form-control" [ngModel]="getTimezone()" (ngModelChange)="setTimezone($event);" [required]="required"/>
                </span>
            </div>
        </div>
    }

    @if (timetableMode != 'periods' && timetableMode != 'dates' && timetableMode != 'event') {
        <h5 class="mb-3">{{ 'pg-timetable-editor.activity-periods' | locTranslate }}</h5>
        <ul class="nav nav-tabs">
            @for (val of value; track val; let i = $index) {
                <li class="nav-item" (click)="editValue = val">
                    <a class="nav-link {{val == editValue ? 'active' : ''}} {{ val.unavailable ? 'text-danger' : '' }}">
                        <span [innerHTML]="formatValuePeriods(val, multi)"></span>
                    </a>
                </li>
            }
            @if (multi) {
                <li class="nav-item" (click)="addDaysItem()">
                    <a class="nav-link text-primary">
                        <i class="fa-regular fa-plus"></i>
                        <span class="ms-1">{{ 'pg-timetable-editor.add-period' | locTranslate }}</span>
                    </a>
                </li>
            }
        </ul>
        @if (editValue != null) {
            <div class="rounded-bottom border border-top-0 px-3 pt-3 bg-white">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        @if (editValue.unavailable) {
                            <h4 class="m-0">
                                {{ 'pg-timetable-editor.unavailable-period' | locTranslate }}
                            </h4>
                        }
                    </div>
                    <div class="text-end">
                        <button class="btn btn-sm btn-primary me-1" (click)="editValueDates(editValue)">
                            <span>{{ 'pg-timetable-editor.edit-dates' | locTranslate }}</span>
                            <i class="fa-regular fa-edit"></i>
                        </button>
                        @if (multi) {
                            <button class="btn btn-sm btn-danger" (click)="removeValue(editValue)">
                                <span>{{ 'pg-timetable-editor.delete-period' | locTranslate }}</span>
                                <i class="fa-regular fa-trash"></i>
                            </button>
                        }
                    </div>
                </div>
                @if (!editValue.unavailable) {
                    @if (timetableMode != 'days') {
                        <div class="mb-2 PGTimetableEditor-Hours">
                            <h5>{{ 'pg-timetable-editor.times-day' | locTranslate }}</h5>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>{{ 'pg-timetable-editor.from-hours' | locTranslate }}</th>
                                        <th>
                                            @if (timetableMode != 'departures') {
                                                {{ 'pg-timetable-editor.to-hours' | locTranslate }}
                                            }
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @if (editValue.hours.length == 0) {
                                        <tr>
                                            <td colspan="2" class="text-muted">{{ 'pg-timetable-editor.no-time-specified' | locTranslate }}</td>
                                        </tr>
                                    }
                                    @for (item of editValue.hours; track item) {
                                        <tr class="PGTimetableEditor-BeginEnd">
                                            <td class="border-bottom-0">
                                                <span>{{item.begin}}</span>
                                            </td>
                                            <td>
                                                @if (timetableMode != 'departures') {
                                                    <span>{{item.end}}</span>
                                                }
                                                <button type="button" class="btn btn-sm btn-danger float-end ms-1" (click)="removeHour(item)"
                                                    [attr.aria-label]="'pg-timetable-editor.a11y.delete-time' | locTranslate">
                                                    <i class="fa-regular fa-trash" aria-hidden="true"></i>
                                                </button>
                                                <button type="button" class="btn btn-sm btn-primary float-end ms-1" (click)="editHourItem(item)"
                                                    [attr.aria-label]="'pg-timetable-editor.a11y.edit-time' | locTranslate">
                                                    <i class="fa-regular fa-edit" aria-hidden="true"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        @if (item.info) {
                                            <tr>
                                                <td colspan="2" class="PGTimetableEditor-Info">
                                                    <div>
                                                        <i class="fa-regular fa-circle-info me-2 text-muted"></i>
                                                        <span>{{getHourInfo(item)}}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                        <tr>
                                            <td colspan="2" class="PGTimetableEditor-WeekDays">
                                                <div>
                                                    @for (day of getWeekdaysList(); track day) {
                                                        <button type="button" class="PGTimetableEditor-WeekDays-Day btn rounded-circle me-1 btn-sm {{item.days[day] ? 'btn-primary' : 'btn-outline-secondary'}}" (click)="item.days[day] = !item.days[day]; onValueChange();"
                                                            [attr.aria-pressed]="!!item.days[day]"
                                                            [attr.aria-label]="getDayName(day, false)">
                                                            <span class="d-block m-0" aria-hidden="true">
                                                                {{getDayName(day, true)}}
                                                            </span>
                                                        </button>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="2">
                                            <button class="btn btn-sm btn-primary float-end" (click)="addHourItem()">
                                                <span>{{ 'pg-timetable-editor.add-time' | locTranslate }}</span>
                                                <i class="fa-regular fa-clock"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    }
                    @if (timetableMode == 'days') {
                        <div class="mb-2 PGTimetableEditor-Hours">
                            <table class="table">
                                <tbody>
                                    @if (editValue.hours.length == 0) {
                                        <tr>
                                            <td colspan="3" class="text-muted">{{ 'pg-timetable-editor.no-time-specified' | locTranslate }}</td>
                                        </tr>
                                    }
                                    @for (item of editValue.hours; track item) {
                                        <tr>
                                            <td>
                                                <div>
                                                    @for (day of getWeekdaysList(); track day) {
                                                        <button type="button" class="PGTimetableEditor-WeekDays-Day btn rounded-circle me-1 btn-sm {{item.days[day] ? 'btn-primary' : 'btn-outline-secondary'}}" (click)="item.days[day] = !item.days[day]; onValueChange();"
                                                            [attr.aria-pressed]="!!item.days[day]"
                                                            [attr.aria-label]="getDayName(day, false)">
                                                            <span class="d-block m-0" aria-hidden="true">
                                                                {{getDayName(day, true)}}
                                                            </span>
                                                        </button>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    }
                }
            </div>
        }
    }
    @if (timetableMode == 'periods') {
        <div class="mb-2 PGTimetableEditor-Days">
            <table class="table">
                <thead>
                    <tr>
                        <th>{{ 'pg-timetable-editor.from-day' | locTranslate }}</th>
                        <th>{{ 'pg-timetable-editor.to-day' | locTranslate }}</th>
                    </tr>
                </thead>
                <tbody>
                    @if (value.length == 0) {
                        <tr>
                            <td colspan="3" class="text-muted">{{ 'pg-timetable-editor.all-year' | locTranslate }}</td>
                        </tr>
                    }
                    @for (val of value; track val) {
                        @if (val.periods != null && val.periods[0] != null) {
                            <tr class="{{ val.unavailable ? 'text-danger' : '' }}">
                                <td>
                                    <span>{{formatPeriodDate(val.periods[0], 'begin')}}</span>
                                </td>
                                <td>
                                    <span>{{formatPeriodDate(val.periods[0], 'end')}}</span>
                                    <button type="button" class="btn btn-sm btn-danger float-end" (click)="removeValue(val)"
                                        [attr.aria-label]="'pg-timetable-editor.a11y.delete-item' | locTranslate">
                                        <i class="fa-regular fa-trash" aria-hidden="true"></i>
                                    </button>
                                </td>
                            </tr>
                        }
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="2">
                            <button class="btn btn-sm btn-primary float-end" (click)="addDaysItem()">
                                <span>{{ 'pg-timetable-editor.add-period' | locTranslate }}</span>
                                <i class="fa-regular fa-calendar"></i>
                            </button>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    }
    @if (timetableMode == 'dates' || timetableMode == 'event') {
        <div>
            <table class="table">
                <thead>
                    <tr>
                        <th>{{ 'pg-timetable-editor.from-date' | locTranslate }}</th>
                        <th>{{ 'pg-timetable-editor.to-date' | locTranslate }}</th>
                        <th>{{ 'pg-timetable-editor.from-hours' | locTranslate }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @if (value.length == 0) {
                        <tr>
                            <td colspan="4" class="text-muted">{{ 'pg-timetable-editor.no-date-specified' | locTranslate }}</td>
                        </tr>
                    }
                    @for (val of value; track val) {
                        <tr class="{{ val.unavailable ? 'text-danger' : '' }}">
                            <td>
                                @if (val.periods != null && val.periods[0] != null) {
                                    <span>{{formatPeriodDate(val.periods[0], 'begin')}}</span>
                                }
                            </td>
                            <td>
                                @if (val.periods != null && val.periods[0] != null) {
                                    <span>{{formatPeriodDate(val.periods[0], 'end')}}</span>
                                }
                            </td>
                            <td>
                                @if (val.hours != null && val.hours[0] != null) {
                                    <span>{{val.hours[0].begin}}</span>
                                }
                            </td>
                            <td>
                                <button type="button" class="btn btn-sm btn-danger float-end ms-1" (click)="removeDate(val)">
                                    <span>{{ 'pg-timetable-editor.delete-date' | locTranslate }}</span>
                                    <i class="fa-regular fa-trash" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="4">
                            <button class="btn btn-sm btn-primary float-end" (click)="addDateItem()">
                                <span>{{ 'pg-timetable-editor.add-date' | locTranslate }}</span>
                                <i class="fa-regular fa-calendar"></i>
                            </button>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    }
</div>

<ng-template #modalAddHour>
    <div class="modal-header">
        <h5 class="modal-title">
            {{ 'pg-timetable-editor.' + (editHourTarget != null ? 'edit' : 'add') + '-time' | locTranslate }}
        </h5>
        <button type="button" class="modal-close btn btn-link" (click)="dismissAddHourModal()"
            [attr.aria-label]="'forms-main.a11y.close' | locTranslate">
            <i class="fa-regular fa-times" aria-hidden="true"></i>
        </button>
    </div>
    <div class="modal-body">
        <div class="container-fluid PGTimetableEditor-Hours-Add">
            <div class="row">
                <div class="col-12 col-sm-6 form-group">
                    <label><b>{{ 'pg-timetable-editor.from-hours' | locTranslate }}</b></label>
                    <div>
                        <app-pg-time-picker [(ngModel)]="editHour.begin" (ngModelChange)="onEditHourChange()"></app-pg-time-picker>
                    </div>
                </div>
                <div class="col-12 col-sm-6 form-group">
                    <label><b>{{ 'pg-timetable-editor.to-hours' | locTranslate }}</b></label>
                    <div>
                        <app-pg-time-picker [(ngModel)]="editHour.end" [readonly]="timetableMode != 'openings'"></app-pg-time-picker>
                        @if (timetableMode != 'openings') {
                            <small class="form-text">{{ 'pg-timetable-editor.to-hours-disabled' | locTranslate }}</small>
                        }
                    </div>
                </div>
                @if (timetableMode == 'slots') {
                    <div class="col-12 col-sm-6 form-group">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="m-0"><b>{{ 'pg-timetable-editor.info-hours' | locTranslate }}</b></label>
                            <div class="PGFormField-Actions">
                                @if (availableLanguages) {
                                    <span class="PGLanguageButtonBar PGFormField-Actions-Translations">
                                        @for (language of availableLanguages; track language) {
                                            <button class="btn btn-sm btn-{{modalAddHourLanguage == language ? 'primary' : 'secondary'}}" (click)="modalAddHourLanguage = language">
                                                {{language.split('_')[0].toUpperCase()}}
                                            </button>
                                        }
                                    </span>
                                }
                            </div>
                        </div>
                        <div>
                            <input class="form-control" [ngModel]="getHourInfo(editHour, modalAddHourLanguage)" (ngModelChange)="setHourInfo(editHour, $event, modalAddHourLanguage); onEditHourChange()"/>
                        </div>
                        <div>
                            <small class="form-text">{{ 'pg-timetable-editor.info-hours-tooltip' | locTranslate }}</small>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="dismissAddHourModal();">
            {{ 'pg-timetable-editor.cancel' | locTranslate }}
        </button>
        <button class="btn btn-primary" (click)="addHour(); dismissAddHourModal();">
            {{ 'pg-timetable-editor.' + (editHourTarget != null ? 'ok' : 'add') | locTranslate }}
        </button>
    </div>
</ng-template>

<ng-template #modalAddDays>
    <div class="modal-header">
        <h5 class="modal-title">
            {{ 'pg-timetable-editor.' + (editPeriodTarget != null || editPeriodValueTarget != null ? 'edit' : 'add') + '-period' | locTranslate }}
        </h5>
        <button type="button" class="modal-close btn btn-link" (click)="dismissAddDaysModal()"
            [attr.aria-label]="'forms-main.a11y.close' | locTranslate">
            <i class="fa-regular fa-times" aria-hidden="true"></i>
        </button>
    </div>
    <div class="modal-body">
        <div class="container-fluid PGTimetableEditor-Days-Add">
            <div class="row">
                <div class="col-12 col-sm-6 form-group">
                    <label><b>{{ 'pg-timetable-editor.from-day' | locTranslate }}</b></label>
                    <div class="d-flex">
                        <select class="form-control" [ngModel]="editPeriod.begin.month" (ngModelChange)="editPeriod.begin.month = stringToNumber($event); onPeriodMonthChange('begin')">
                            @for (option of getMonthSelectOptions(); track option; let i = $index) {
                                <option value="{{i + 1}}">{{option}}</option>
                            }
                        </select>
                        <select class="form-control ms-1" [ngModel]="editPeriod.begin.day" (ngModelChange)="editPeriod.begin.day = stringToNumber($event);">
                            @for (option of periodDaySelectOptions['begin']; track option) {
                                <option value="{{option}}">{{option}}</option>
                            }
                        </select>
                    </div>
                </div>
                <div class="col-12 col-sm-6 form-group">
                    <label><b>{{ 'pg-timetable-editor.to-day' | locTranslate }}</b></label>
                    <div class="d-flex">
                        <select class="form-control" [ngModel]="editPeriod.end.month" (ngModelChange)="editPeriod.end.month = stringToNumber($event); onPeriodMonthChange('end')">
                            @for (option of getMonthSelectOptions(); track option; let i = $index) {
                                <option value="{{i + 1}}">{{option}}</option>
                            }
                        </select>
                        <select class="form-control ms-1" [ngModel]="editPeriod.end.day" (ngModelChange)="editPeriod.end.day = stringToNumber($event);">
                            @for (option of periodDaySelectOptions['end']; track option) {
                                <option value="{{option}}">{{option}}</option>
                            }
                        </select>
                    </div>
                </div>
                <div class="col-12 col-sm-6 form-group">
                    <label><b>{{ 'pg-timetable-editor.year' | locTranslate }}</b></label>
                    <div class="d-flex">
                        <select class="form-control" [ngModel]="getPeriodYear()" (ngModelChange)="setPeriodYear($event)">
                            <option value="">{{ 'pg-timetable-editor.year-placeholder' | locTranslate }}</option>
                            @for (option of getYearSelectOptions(); track option) {
                                <option value="{{option}}">{{option}}</option>
                            }
                        </select>
                    </div>
                </div>
                @if (multi && editPeriodTarget == null && editPeriodValueTarget == null) {
                    <div class="col-12 col-sm-6 form-group">
                        <label><b>{{ 'pg-timetable-editor.unavailable-period' | locTranslate }}</b></label>
                        <div class="d-flex">
                            <app-pg-switch color="danger" [(ngModel)]="editPeriodUnavailable"></app-pg-switch>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="dismissAddDaysModal();">
            {{ 'pg-timetable-editor.cancel' | locTranslate }}
        </button>
        <button class="btn btn-primary" (click)="addDays(); dismissAddDaysModal();">
            {{ 'pg-timetable-editor.' + (editPeriodTarget != null || editPeriodValueTarget != null ? 'ok' : 'add') | locTranslate }}
        </button>
    </div>
</ng-template>

<ng-template #modalAddDate>
    <div class="modal-header">
        <h5 class="modal-title">
            {{ 'pg-timetable-editor.add-date' | locTranslate }}
        </h5>
        <button type="button" class="modal-close btn btn-link" (click)="dismissAddDateModal()"
            [attr.aria-label]="'forms-main.a11y.close' | locTranslate">
            <i class="fa-regular fa-times" aria-hidden="true"></i>
        </button>
    </div>
    <div class="modal-body">
        <div class="container-fluid PGTimetableEditor-Days-Add">
            <div class="row">
                <div class="col-12 col-sm-6 form-group">
                    <input type="date" class="form-control" [(ngModel)]="editDateFrom"/>
                </div>
                <div class="col-12 col-sm-6 form-group">
                    <input type="date" class="form-control" [(ngModel)]="editDateTo"/>
                </div>
            </div>

            @if (timetableMode == 'event') {
                <div class="row">
                    <div class="col-12 col-sm-6 form-group">
                        <label><b>{{ 'pg-timetable-editor.from-hours' | locTranslate }}</b></label>
                        <div>
                            <app-pg-time-picker [(ngModel)]="editEventHour"></app-pg-time-picker>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="dismissAddDateModal();">
            {{ 'pg-timetable-editor.cancel' | locTranslate }}
        </button>
        <button class="btn btn-primary" (click)="addDate(); dismissAddDateModal();">
            {{ 'pg-timetable-editor.add' | locTranslate }}
        </button>
    </div>
</ng-template>